import React from 'react';

function AllowNotifications() {
    return (
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100vh'}}>
            <img src={require('./allowNotifications.jpg')} width={300} height={300} />
            <h1>Please allow notifications for this site to continue</h1>
        </div>
    );
}
export default AllowNotifications;